<script lang="ts" setup>
import bolt from "@/assets/image/services/heatPumps/bolt.svg";
import thermostat from "@/assets/image/services/heatPumps/device_thermostat.svg";
import eco from "@/assets/image/services/heatPumps/eco.svg";
import verified from "@/assets/image/services/heatPumps/verified.svg";
import { $t } from "@/i18n";
import img1 from "@/assets/image/services/heatPumps/carousel-pumpe-konsultacije.jpg";
import img2 from "@/assets/image/services/heatPumps/carousel-pumpe-servis.jpg";
import img3 from "@/assets/image/services/heatPumps/carousel-pumpe-ugradnja.png";
import { useDefaultStore } from "@/store";
import { $te } from "@/assets/ts/helpers";

const info = computed(() => [
  {
    icon: bolt,
    title: $t("app.heatPumps.info.1.title"),
    text: $t("app.heatPumps.info.1.text"),
  },
  {
    icon: thermostat,
    title: $t("app.heatPumps.info.2.title"),
    text: $t("app.heatPumps.info.2.text"),
  },
  {
    icon: eco,
    title: $t("app.heatPumps.info.3.title"),
    text: $t("app.heatPumps.info.3.text"),
  },
  {
    icon: verified,
    title: $t("app.heatPumps.info.4.title"),
    text: $t("app.heatPumps.info.4.text"),
  },
]);

const store = useDefaultStore();
const carousel = computed(() => [
  {
    image: img1,
    text: $t("app.heatPumps.carousel.1"),
    active: true,
  },
  {
    image: img2,
    text: $t("app.heatPumps.carousel.2"),
    active: false,
  },
  {
    image: img3,
    text: $t("app.heatPumps.carousel.3"),
    active: false,
  },
]);

useHead({
  title: `${$te("app.heatPumps.heading")} | ${store.SITE_NAME}`,
  meta: [
    {
      name: "title",
      content: `${$te("app.heatPumps.heading")} | ${store.SITE_NAME}`,
    },
    {
      name: "description",
      content: $te("app.heatPumps.paragraph1"),
    },
    { name: "robots", content: "index, follow" },
    {
      property: "og:title",
      content: `${$te("app.heatPumps.heading")} | ${store.SITE_NAME}`,
    },
    {
      property: "og:description",
      content: $te("app.heatPumps.paragraph1"),
    },
    { property: "og:site_name", content: store.SITE_NAME },
  ],
});
</script>

<template>
  <m-page class="bg-text-dark">
    <div class="mx-auto max-w-screen-xl">
      <services-page-heading :heading="$t('app.heatPumps.heading')"></services-page-heading>
      <services-paragraph class="mb-8 max-w-[972px]" :text="$t('app.heatPumps.paragraph1')"></services-paragraph>
      <base-button :text="$t('app.base.contactUs')" route-name="ContactPage" class="mb-12 md:mb-22" bg-color="text-light"></base-button>
      <p class="text-text-white mb-8 text-xl leading-[120%] font-semibold md:text-2xl">{{ $t("app.heatPumps.infoTitle") }}</p>
      <div class="mb-8 grid gap-6 md:mb-22 md:grid-cols-2">
        <services-info-card v-for="(i, index) in info" :key="index" :icon="i.icon" :title="i.title" :text="i.text"></services-info-card>
      </div>
      <services-paragraph class="mb-6 max-w-[779px]" :text="$t('app.heatPumps.paragraph2')"></services-paragraph>
      <carousel-comp v-if="!store.isWiderThan1307" :carousel="carousel">
        <template #default="{ item, active }">
          <services-image-card :text="item.text ?? ''" :image="item.image" :active="active"></services-image-card>
        </template>
      </carousel-comp>
      <template v-else><services-wide-carousel :carousel="carousel"></services-wide-carousel></template>
      <services-paragraph :text="$t('app.heatPumps.paragraph3')" class="mt-8"></services-paragraph>
      <services-paragraph :text="$t('app.heatPumps.paragraph4')"></services-paragraph>
    </div>
  </m-page>
</template>
